export default {
  "orders.title": "Orders",
  "orders.subtitle": "Track orders from acceptance to receipt completion",

  "orders.tab.new": "New",
  "orders.tab.active": "Active",
  "orders.tab.completed": "Completed",
  "orders.tab.cancelled": "Cancelled",

  "orders.col.order": "Order no.",
  "orders.col.customer": "Customer",
  "orders.col.priority": "Priority",
  "orders.col.fulfillment": "Pickup & delivery",
  "orders.col.total": "Total amount",
  "orders.col.status": "Status",
  "orders.col.actions": "Action",

  "orders.empty.new": "No new orders awaiting approval",
  "orders.empty.active": "No active orders right now",
  "orders.empty.completed": "No completed orders",
  "orders.empty.cancelled": "No cancelled orders",
  "orders.error": "Could not load orders",
  "orders.errorDetail": "Could not load order details",
  "orders.errorAction": "Could not complete the action, please try again.",
  "orders.stateChanged": "The order status changed. Data has been refreshed.",
  "orders.notFound": "The order could not be found or does not belong to your laundry.",
  "orders.notFoundBack": "Back to orders",
  "orders.backToList": "Back to orders",
  "orders.demoNote": "This is a preview with demo data.",

  "orders.detail.customer": "Customer details",
  "orders.detail.customerName": "Customer name",
  "orders.detail.phone": "Phone number",
  "orders.detail.call": "Call",
  "orders.detail.orderInfo": "Order details",
  "orders.detail.fulfillment": "Pickup & delivery method",
  "orders.detail.total": "Current total amount",
  "orders.detail.status": "Current status",
  "orders.detail.priority": "Order priority",
  "orders.detail.driver": "Driver",
  "orders.detail.createdAt": "Created at",
  "orders.detail.items": "Items list",
  "orders.detail.itemsCount": "Items",
  "orders.detail.units": "pcs",

  "orders.items.type": "Item type",
  "orders.items.service": "Service type",
  "orders.items.qty": "Quantity",

  "orders.amount.title": "Amount breakdown",
  "orders.amount.note": "Item value is calculated from the approved service prices, then the delivery fee is added to reach the final total.",
  "orders.amount.unitPrice": "unit",
  "orders.amount.subtotal": "Items value",
  "orders.amount.deliveryFee": "Delivery fee",
  "orders.amount.total": "Final total",
  "orders.amount.unpriced": "Some items could not be priced with approved prices; the final total is shown as recorded by the system.",

  "orders.actions.title": "Available actions",
  "orders.actions.accept": "Accept order",
  "orders.actions.reject": "Reject order",
  "orders.actions.receive": "Received — reviewing order",
  "orders.actions.startProgress": "In progress",
  "orders.actions.ready": "Ready for delivery",
  "orders.actions.assignDriver": "Assign sub-driver",

  "orders.accept.confirm.title": "Accept the order?",
  "orders.accept.confirm.text": "The order will be accepted and its journey will start according to the pickup & delivery method.",
  "orders.accept.confirm.confirm": "Accept order",
  "orders.reject.confirm.title": "Reject the order?",
  "orders.reject.confirm.text": "The order will be cancelled and the amount refunded to the customer per the approved refund mechanism.",
  "orders.reject.confirm.confirm": "Confirm rejection",
  "orders.receive.confirm.title": "Confirm receipt?",
  "orders.receive.confirm.text": "Were the clothes physically received at the laundry?",
  "orders.receive.confirm.confirm": "Confirm receipt",
  "orders.ready.confirm.title": "Ready for delivery?",
  "orders.ready.confirm.text": "Is the service complete and the order ready for delivery?",
  "orders.ready.confirm.confirm": "Ready for delivery",
  "orders.confirm.cancel": "Cancel",

  "orders.toast.accepted": "Order accepted",
  "orders.toast.rejected": "Order rejected",
  "orders.toast.received": "Clothes received and contents review started",
  "orders.toast.reviewAdopted": "Contents review adopted",
  "orders.toast.started": "Order execution started",
  "orders.toast.ready": "Order marked ready for delivery",
  "orders.toast.assigned": "Sub-driver assigned to the task",

  "orders.accept.pickupNote": "The system started searching for a pickup driver.",
  "orders.accept.dropoffNote": "Waiting for the customer to drop the clothes at the laundry.",
  "orders.receive.pickupDriverNote": "The system reported that the pickup driver handed the clothes to the laundry.",
  "orders.duration.startsNote": "The approved execution duration starts when the laundry actually receives the order.",
  "orders.ready.deliveryNote": "The system started searching for a delivery driver.",
  "orders.ready.pickupNote": "Waiting for the customer to pick the order up from the laundry.",

  "orders.review.title": "Review order contents",
  "orders.review.note": "Review the actually received items and compare them with the recorded items.",
  "orders.review.recordedType": "Recorded item type",
  "orders.review.actualType": "Actual item type",
  "orders.review.service": "Service type",
  "orders.review.serviceLocked": "The service type chosen by the customer, display only.",
  "orders.review.recordedQty": "Recorded quantity",
  "orders.review.actualQty": "Actual quantity",
  "orders.review.addedBadge": "Added item",
  "orders.review.recordedBadge": "Original item",
  "orders.review.addItem": "Add received item",
  "orders.review.addItemServiceNote": "Contact the customer externally to agree the service for the added item, then record the agreed service.",
  "orders.review.selectItem": "Select item type",
  "orders.review.selectService": "Select service type",
  "orders.review.add": "Add",
  "orders.review.remove": "Remove",
  "orders.review.cancelAdd": "Cancel",
  "orders.review.summary": "Items summary after review",
  "orders.review.unitsTotal": "Total items",
  "orders.review.previousTotal": "Previous amount",
  "orders.review.finalTotal": "Expected final amount",
  "orders.review.diff": "Amount difference",
  "orders.review.diffIncrease": "Increase",
  "orders.review.diffDecrease": "Decrease",
  "orders.review.diffNone": "No change",
  "orders.review.adopt": "Adopt review",
  "orders.review.issue.unavailable": "The selected service is unavailable for the corrected item type and needs approved handling.",
  "orders.review.issue.empty": "There is no actual item, and this case needs approved handling.",
  "orders.review.issue.hint": "Resolve the flagged points before adopting the review.",
  "orders.review.adoptedNote": "The contents review was adopted. You can start execution.",
  "orders.review.itemsReadonlyNote": "The adopted items are now display only.",

  "orders.escalation.title": "Needs a driver assignment",
  "orders.escalation.text": "The customer chose to wait and the grace period ended with no delivery task accepted. You can assign an available sub-driver.",
  "orders.escalation.assign": "Assign sub-driver",
  "orders.escalation.note": "The task stays available to drivers in parallel until one accepts it or it is assigned manually.",

  "orders.assign.title": "Assign sub-driver",
  "orders.assign.note": "The task is mandatorily assigned to the sub-driver per the system mechanism.",
  "orders.assign.available": "Available sub-drivers",
  "orders.assign.phone": "Phone number",
  "orders.assign.empty": "No sub-driver is available right now",
  "orders.assign.emptyHint": "A busy or unavailable driver cannot be assigned. Refresh the list to try again.",
  "orders.assign.refresh": "Refresh list",
  "orders.assign.confirm": "Confirm assignment",
  "orders.assign.error": "Could not load available drivers",
  "orders.assign.unavailable": "The task or driver is no longer available. Refresh the list and try again.",

  "orders.completed.note": "The order receipt is complete. Items and final amount are display only.",
  "orders.cancelled.reason": "Cancellation reason",
  "orders.cancelled.refund": "Refund status",
  "orders.cancelReason.customer_cancelled": "The customer cancelled the order",
  "orders.cancelReason.laundry_rejected": "The laundry rejected the order",
  "orders.refund.pending": "Refund pending",
  "orders.refund.processing": "Refund processing",
  "orders.refund.completed": "Refund completed",
  "orders.refund.none": "No refund required",

  "orders.smartbox.title": "Smart box",
  "orders.smartbox.stage.pickup": "Pickup",
  "orders.smartbox.stage.delivery": "Delivery",
  "orders.smartbox.note": "Description as reported by the system; the laundry cannot change the order method or control the lock."
};